let url = 'https://api.zenplus.art/tasks/';
if (process.env.NODE_ENV === 'development') {
  url = 'http://127.0.0.1:8181/';
  // url = 'http://192.168.0.23:8181/';
}
export const apiBaseUrl = url;



// WEBPACK FOOTER //
// ./src/api.ts